export default __webpack_public_path__ + "static/media/drip-Wash.4f70d2f4.jpg";